export default function isTaxInclusive(
  isCustomTax,
  taxInclusiveSetting,
  country,
  countryList
) {
  const countryVal = (country && country.value) || null
  if (isCustomTax) {
    return false
  }
  if (
    taxInclusiveSetting &&
    countryVal &&
    countryList.find(c => c === countryVal)
  ) {
    return taxInclusiveSetting
  }
  return false
}
